import { render, staticRenderFns } from "./Shareholder.vue?vue&type=template&id=0f0cf550&scoped=true&"
import script from "./Shareholder.vue?vue&type=script&lang=js&"
export * from "./Shareholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0cf550",
  null
  
)

export default component.exports